import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { Save } from "@mui/icons-material";

const EditForm = ({ initialData, onUpdate }) => {
  const [title, setTitle] = useState(initialData.title);
  const [content, setContent] = useState(initialData.content);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updatedData = {
      id: initialData.id,
      title: title,
      faq_order: initialData.faq_order, // Keep the existing order
      content: content,
    };
    onUpdate(updatedData);
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        fullWidth
        required
        margin="normal"
      />
      <TextField
        label="Content"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        fullWidth
        required
        margin="normal"
        multiline
        rows={4}
      />
      <Button
        type="submit"
        variant="outlined"
        color="success"
        endIcon={<Save />}
      >
        Update FAQ
      </Button>
    </form>
  );
};

export default EditForm;
